export default __webpack_public_path__ + "static/media/1-hour-meditation-music-alpha-brain-waves-for-deep-relaxation-and-creative-thinking.1da9606b.mp3";